import { IPublicClientApplication } from '@azure/msal-browser';
import { getToken } from '../auth/authService';

// Microsoft Dataverse Global Discovery Service (commercial cloud). Lists the
// Dataverse environment instances the signed-in user has access to. Used by the
// Setup Wizard to resolve which environment this tenant should talk to.
//
// The scope is a SEPARATE resource from func-dagrun-prod / the environment
// itself. Verified live: token aud = https://globaldisco.crm.dynamics.com,
// scp = user_impersonation.
export const GLOBAL_DISCOVERY_SCOPES = ['https://globaldisco.crm.dynamics.com/user_impersonation'];

const DISCOVERY_URL =
  'https://globaldisco.crm.dynamics.com/api/discovery/v2.0/Instances?$select=ApiUrl,FriendlyName';

export interface DiscoveredEnvironment {
  friendlyName: string;
  apiUrl: string;
}

interface DiscoveryInstance {
  ApiUrl?: string;
  FriendlyName?: string;
}

/**
 * Returns the Dataverse environments the caller can access. An empty array
 * (tenant has no environment provisioned) is a valid, non-error result.
 */
export async function discoverEnvironments(
  pca: IPublicClientApplication,
): Promise<DiscoveredEnvironment[]> {
  const token = await getToken(pca, GLOBAL_DISCOVERY_SCOPES);
  const res = await fetch(DISCOVERY_URL, {
    headers: { Authorization: `Bearer ${token}`, Accept: 'application/json' },
  });
  if (!res.ok) {
    throw new Error(`Global Discovery Service returned ${res.status}.`);
  }
  const data = (await res.json()) as { value?: DiscoveryInstance[] };
  return (data.value ?? [])
    .filter((i) => i.ApiUrl)
    .map((i) => ({ friendlyName: i.FriendlyName ?? i.ApiUrl!, apiUrl: i.ApiUrl! }));
}
